<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix flex flex-b">
				<h4>积分配置</h4>
				<el-button style="float: right; padding: 3px 0;font-size: 16px;" @click="addPointsDialog"
					type="text">积分规则</el-button>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="新用户注册" prop="REGISTER" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.REGISTER" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="每日签到" prop="SIGN" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.SIGN" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="完成已购章节学习" prop="CHAPTER_STUDY" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.CHAPTER_STUDY" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="分享已购课程" prop="SHARE_COURSE" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.SHARE_COURSE" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="评论已购章节" prop="EAVLUATE" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.EAVLUATE" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="邀请新用户" prop="INVITE" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.INVITE" placeholder="请输入"></el-input>
				</el-form-item>
				<el-form-item label="完善个人信息" prop="IMPROVE_INFO" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.IMPROVE_INFO" placeholder="请输入"></el-input>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" @click="submitForm('ruleForm')">更新</el-button>
		</el-card>

		<PointsManageDialog :dialogProp="editdialogVisible" @input="closeDialog" @confirm="confirmDialog">
		</PointsManageDialog>
	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import PointsManageDialog from './components/PointsManageDialog.vue';
	import {
		getConfigList,
		updateConfigList,
		getConfigDetail
	} from "@/api/marketing"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				editdialogVisible:false,
				labelWidth: '150px',
				radio: '2',
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				value: '500',
				ruleForm: {
					REGISTER: '',
					SIGN: '',
					CHAPTER_STUDY: '',
					SHARE_COURSE: '',
					EAVLUATE: '',
					INVITE: '',
					IMPROVE_INFO:''
				},
				rules: {
					REGISTER: [{
							required: true,
							message: '请输入',
							trigger: 'blur'
						},
					],
					SIGN: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					CHAPTER_STUDY: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					SHARE_COURSE: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					EAVLUATE: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					INVITE: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					IMPROVE_INFO: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
				}
			};
		},
		components: {
			CommonPagination,
			PointsManageDialog
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getDoubao()
		},
		methods: {
			closeDialog(){
				this.editdialogVisible = false
			},
			confirmDialog(){},
			addPointsDialog() {
				this.editdialogVisible = true
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.updateDetail()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async updateDetail(){
				//新用户注册
				this.updateConfigDetail('REGISTER')
				//每日签到
				this.updateConfigDetail('SIGN')
				//完成已购章节学习
				this.updateConfigDetail('CHAPTER_STUDY')
				//分享已购课程
				this.updateConfigDetail('SHARE_COURSE')
				//评论已购章节
				this.updateConfigDetail('EAVLUATE')
				//邀请新用户
				this.updateConfigDetail('INVITE')
				//完善个人信息
				this.updateConfigDetail('IMPROVE_INFO')
				this.$message.success('更新成功')
			},
			async updateConfigDetail(key){
				let postData = {
					key:key,
					value:this.ruleForm[key]
				};
				const {
					status,
					data
				} = await updateConfigList(postData);
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			async getDoubao() {
				let that= this
				let postData = {
				};
				const {
					status,
					data
				} = await getConfigList(postData);
				if (status !== 200) return;
				this.doubaoList = data.result;
				this.doubaoList.forEach(item=>{
					if(item.key == 'REGISTER'){
						//新用户注册
						that.getConfigDetail('REGISTER')
					}
					if(item.key == 'SIGN'){
						//每日签到
						that.getConfigDetail('SIGN')
					}
					if(item.key == 'CHAPTER_STUDY'){
						//完成已购章节学习
						that.getConfigDetail('CHAPTER_STUDY')
					}
					if(item.key == 'SHARE_COURSE'){
						//分享已购课程
						that.getConfigDetail('SHARE_COURSE')
					}
					if(item.key == 'EAVLUATE'){
						//评论已购章节
						that.getConfigDetail('EAVLUATE')
					}
					if(item.key == 'INVITE'){
						//邀请新用户
						that.getConfigDetail('INVITE')
					}
					if(item.key == 'IMPROVE_INFO'){
						//完善个人信息
						that.getConfigDetail('IMPROVE_INFO')
					}
				})
			},
			async getConfigDetail(key) {
				let postData = {
					key:key
				};
				const {
					status,
					data
				} = await getConfigDetail(postData);
				if (status !== 200) return;
				this.ruleForm[key] = data.result.value
			},
			goBack() {
				this.$router.go(-1)
			},
			handleClickBack() {
				this.$router.back(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>